import React from 'react';
import SlideoutLayout from '../../layout/slideout/SlideoutLayout';
import KwPanel from '../../common/KwPanel';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import FormToggleBool from '../../common/FormToggleBool';
import Button from '../../common/Button';
import ConfirmationHeader from '../../common/ConfirmationHeader';
import { useTranslation, Trans } from 'react-i18next';
import { useAppDispatch } from '../../../hooks';
import { unarchiveGame } from '../../../reducers/gameReducer';

export interface UnarchiveProps {
  done: () => void;
  id: string;
  cancel: () => void;
}

function Unarchive({ done, id, cancel }: UnarchiveProps) {
  const { handleSubmit, control } = useForm();
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const handleUnarchive = (data: any) => {
    dispatch(
      unarchiveGame({ id, restorePendingRequests: data.restorePendingRequests })
    )
      .unwrap()
      .then(() => {
        toast.success(t('Game successfully unarchived'));
        done();
      })
      .catch(() => {
        toast.error(t('Failed to unarchive game'));
      });
  };

  return (
    <SlideoutLayout
      title={t('Unarchive confirmation')}
      cancel={cancel}
    >
      <KwPanel>
        <ConfirmationHeader text={t('Are you sure?')} />
        <p>
          {t(
            'Once the game is unarchived, users will be able to request keys again.'
          )}
        </p>
        <p>
          <Trans i18nKey="unarchiveConfirmation" components={{ bold: <b /> }}>
            You can also <strong>&apos;Restore pending requests&apos;</strong> from
            before the game was archived.
          </Trans>
        </p>
        <FormToggleBool
          control={control}
          name="restorePendingRequests"
          label={t('Restore pending requests?')}
          defaultValue={false}
        />
        <hr />
        <Button
          className="btn btn-primary me-2"
          onClick={handleSubmit(handleUnarchive)}
          text={t("Yes, unarchive the game and it's skus")}
        />
        <Button
          className="btn btn-default"
          onClick={cancel}
          autoFocus={true}
          text={t('No, cancel')}
        />
      </KwPanel>
    </SlideoutLayout>
  );
}

export default Unarchive;
